import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';

@Component({
  selector: 'app-helpbutton-departments-breadcrumb-card',
  templateUrl: './helpbutton-departments-breadcrumb-card.component.html',
  styleUrls: ['./helpbutton-departments-breadcrumb-card.component.scss']
})
export class HelpbuttonDepartmentsBreadcrumbCardComponent implements OnInit {

  @Input() departments;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private userStorageService: UserStorageService,
    private departmentsService: DepartmentsHelpbuttonService) {
      this.viewDisposition = 'grid';
    }

  ngOnInit() {
    if (this.userStorageService.getFilterDepartments()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.departmentsService.toggleDepartmentsDisposition(viewDis);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public createDepartment() {
    this.router.navigate(['../../department'], {relativeTo: this.activatedRoute});
  }

  public search(event) {
    this.departmentsService.searchDepartments(event.target.value);
  }
}
